module.exports = __webpack_public_path__ + "static/img/contribution_banner_iphone.45bbfed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contribution_banner_iphone.jpg
// module id = dl1m
// module chunks = 1